import { Pipe, PipeTransform } from '@angular/core';
import { DateUtilsService } from '../services/date-utils.service';

@Pipe({
  name: 'utcTime'
})
export class UtcTimePipe implements PipeTransform {
  constructor(private dateUtils: DateUtilsService) {}
  
  transform(value: any, format: string = 'HH:mm'): string {
    return this.dateUtils.formatDateTimeToLocal(value, format);
  }
}
